module.exports = __webpack_public_path__ + "img/coin2.543f0a92.png";